// Function to find unique count of Uttrakhand bar IDs
const findUniqueCountOfUttrakhandBarId = (voucherDetailsList) => {
    const uniqueIds = new Set();
    
    // Debugging: Check if the input is an array
    if (!Array.isArray(voucherDetailsList)) {
        console.error('Expected an array for voucherDetailsList:', voucherDetailsList);
        return 0;
    }

    voucherDetailsList.forEach(voucher => {
        // Debugging: Log each voucher object to check its structure
        console.log('Processing voucher:', voucher);

        // Check if the uttrakhandBarId exists
        if (voucher.advocateBarId !== undefined) {
            uniqueIds.add(voucher.advocateBarId);
        } else {
            console.warn('uttrakhandBarId is undefined for voucher:', voucher);
        }
    });

    // Debugging: Log the set of unique IDs
    console.log('Unique Uttrakhand Bar IDs:', uniqueIds);

    return uniqueIds.size;
};



export default findUniqueCountOfUttrakhandBarId;
